import OurCultureSection from "../components/OurCultureSection"
import TeamSection from '../components/TeamSection'
import TeamGrid from '../components/TeamGrid'
import Partners from '../components/Partners'
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';

const goals = [
  {
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744980313/image_n8gcnj.png',
    title: 'Food security',
    description: 'End hunger, achieve food security, improved nutrition and promote sustainable agriculture',
  },
  {
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744980313/image_19_kxewkk.png',
    title: 'Gender Equality',
    description: 'Achieve gender equality and empower all women and girls',
  },
  {
    image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744980313/image-1_fpxqyf.png',
    title: 'Jobs',
    description: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work',
  },
];

const sdgGoals = [
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image_dpwkgu.png',
    text: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984703/image_1642_jtqpc3.png',
    text: 'Achieve gender equality and empower all women and girls',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-1_vootwy.png',
    text: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-2_rwjuve.png',
    text: 'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
  },
  {
    icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-3_jspfjb.png',
    text: 'Ensure sustainable consumption and production patterns',
  },
];

const About = () => {
  const [activeTab, setActiveTab] = useState("farmers");
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState(0);

  const buttons = [
    { label: "Why Register", path: "/Why" },
    { label: "Challenges", path: "/challenge" },
    { label: "Solutions", path: "/solution" },
    { label: "Benefits", path: "/benefits" },
    { label: "Organization", path: "/Organization" },
    { label: "-", path: "/" },
    { label: "-", path: "/" },
  ];

  return (
    <div className='bg-[#F8F9F9]'>
      <div className='md:pt-10 pt-3'>
        <div className='md:px-20 px-4'>
          <div> 
            <h1 className='md:text-[36px] text-[18px] font-extrabold text-black'>About us</h1>
          </div>
          
          {/* Navigation Buttons */}
          <div className="grid grid-cols-7 gap-1 md:gap-2 w-full mb-3 md:mb-8">
            {buttons.map((btn, index) => (
              <button
                key={index}
                onClick={() => navigate(btn.path)}
                className={`
                  h-3 md:h-10 lg:h-[40px] 
                  rounded-[2px] shadow-md 
                  text-[6px] md:text-sm lg:text-[14px] font-normal
                  bg-[#152C24] text-white
                  border-b-2 
                  ${
                    activeButton === index
                      ? "border-[#FDBD26]"
                      : "border-gray-400"
                  }
                  hover:bg-[#1a3a30] transition-colors duration-200
                `}
              >
                {btn.label}
              </button>
            ))}
          </div>

          {/* Main Description */}
          <p className='md:text-[40px] text-[10px] font-normal md:mt-3 mt-1 leading-tight'>
            The FarmNet mobile app is a digital tool designed to help farmers efficiently manage their agricultural operations through features like farm activity tracking, crop planning, and resource management. It connects users with service providers, agronomists, and input suppliers, while also offering real-time market price updates and buyer linkages to improve market access. The app supports geolocation for field mapping, provides timely alerts and notifications, and in some cases, allows remote control of farming devices. Available for Android, FarmNet is aimed at modernizing farming practices and increasing productivity, especially for smallholder farmers in Africa.
          </p>

          {/* Top Image Section */}
          <div className="w-full mt-3 md:mt-2">
            <div className="">
              <img
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759744335/image_2548_1_z6ogri.png"
                alt="Farmer"
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Green Box Section */}
            <div className="bg-[#152C24] text-white -mx-3 md:-mx-20 px-4 md:px-20 py-4 md:py-10 mt-3 md:mt-6">
              <h2 className="md:text-2xl text-[10px] font-bold mb-3 md:mb-6">ABOUT US</h2>

              <h3 className="md:text-2xl text-[10px] font-bold mb-3 md:mb-6 leading-tight">
                Empowering Farmers. Connecting Agriculture. Transforming Lives.
              </h3>

              <p className="mb-2 md:mb-4 md:text-2xl text-[8px] leading-tight">
                FarmNet is a farmer-first digital platform built to empower smallholder and 
                commercial farmers across Africa. Through smart, accessible technology, 
                we connect farmers with the tools, information, and networks they need 
                to build successful, sustainable agribusinesses.
              </p>

              <p className="mb-2 md:mb-4 md:text-2xl text-[8px] leading-tight">
                Whether you need access to reliable input suppliers, local or national markets, 
                expert training, or agri-support services, FarmNet makes it easy to find 
                trusted resources—fast. Our platform bridges critical gaps in the 
                agricultural value chain, helping farmers increase productivity, reduce risk, 
                and unlock new opportunities.
              </p>

              <p className="mb-2 md:mb-4 md:text-2xl text-[8px] leading-tight">
                But FarmNet is more than just a platform—it's a movement toward agricultural 
                transformation. By placing powerful digital tools into the hands of those 
                who grow our food, we're driving self-reliance, supporting livelihoods, 
                and advancing food security across the continent.
              </p>

              <p className="md:text-2xl text-[8px] leading-tight">
                Rooted in access, reliability, and empowerment, FarmNet offers a secure, 
                user-friendly space where farmers, buyers, and service providers can 
                connect, trade, and grow—together.
              </p>
            </div>
          </div>

          {/* Full Width Image with Button */}
          <div className="w-full md:mt-6 mt-3">
  <div className="relative w-full h-full">
    <img
      src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759749093/image_2549_j53adx.png"
      alt="Farmers Network"
      className="w-full h-full object-cover"
    />
    
    {/* Centered Icon */}
    <div className="absolute inset-0 flex items-center justify-center">
      <img
        src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759780855/image_1784_dbnekn.png"
        alt="Farmers Network Icon"
        className="w-[133px] h-[133px] object-contain"
      />
    </div>
    
    {/* Button at Bottom */}
    <div className="absolute bottom-2 right-2 md:bottom-4 md:right-4">
      <a
        href="/argitech1"
        className="w-[100px] md:w-[400px] h-[12px] md:h-[50px] shadow-xl flex items-center justify-center rounded-[2px] md:rounded-[8px] font-bold text-[6px] md:text-[20px] text-white"
        style={{
          background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
        }}
      >
        <span className="flex-1 text-center">Real Struggles of Entrepreneurship</span>
        <img
          src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756410811/Expand_right_1_bpdsxb.png"
          alt="arrow"
          className="w-[8px] md:w-[23px] h-[8px] md:h-[21px] mr-1 md:mr-4"
        />
      </a>
    </div>
  </div>

  {/* Content Section */}
  <div className="py-4 md:py-8 space-y-3 md:space-y-6">
    {/* Quote */}
    <p className="md:text-[24px] text-[8px] italic leading-tight">
      "The success of our organization is rooted in the success of the farmers we serve.{" "}
      <span className="font-bold">
        Empowering farmers to grow sustainably isn't just our mission - it's the foundation
        of everything we do.
      </span>
    </p>
    <p className="font-bold md:text-[24px] text-[8px]">~ Allan Oyier, Founder & CEO, Farmers Network</p>

    {/* Mission */}
    <div>
      <h2 className="md:text-[24px] text-[10px] font-bold">Mission</h2>
      <p className="md:text-[24px] text-[8px] leading-tight">
        To empower farmers and agri-entrepreneurs by providing access to digital tools,
        real-time agricultural opportunities, and a trusted platform that connects them to
        markets, services, and support—anytime, anywhere.
      </p>
    </div>

    {/* Vision */}
    <div>
      <h2 className="md:text-[24px] text-[10px] font-bold">Vision</h2>
      <p className="md:text-[24px] text-[8px] leading-tight">
        To be Africa's leading digital platform for inclusive agricultural growth—fueling food
        security, job creation, and sustainable farming through innovation and technology.
      </p>
    </div>

    {/* What We Do */}
    <div>
      <h2 className="md:text-[24px] text-[10px] font-bold">What We Do</h2>
      <ul className="list-disc pl-4 md:pl-12 space-y-1 md:space-y-2 md:text-[24px] text-[8px] leading-tight">
        <li>
          Connect Farmers with Verified Service Providers - We match farmers with trusted agri-service providers, suppliers, buyers, and experts based on their needs and location.
        </li>
        <li>
          Create Opportunities Across the Agricultural Value Chain - Farmers can showcase their produce, receive training, and access markets, financial services, and quality farming inputs.
        </li>
        <li>
          Enable Safe & Seamless Transactions - FarmNet provides a secure platform for trading, accessing services, and managing digital payments with confidence.
        </li>
        <li>
          Support Agricultural and Business Growth - From farm profiling to digital recordkeeping, market insights, and learning resources—FarmNet equips farmers with tools to professionalize and grow their agribusinesses.
        </li>
      </ul>
    </div>
  </div>
</div>
        </div>

        {/* Our Culture Section */}
        <div className='md:px-20 px-4 pt-4 md:pt-6 bg-[#142B24]'>
          <h1 className='md:text-[32px] text-[14px] font-bold md:mt-8 text-[#FDBD26]'>OUR CULTURE</h1>
          <OurCultureSection/>
        </div>

        {/* Culture Words Section */}
        <div className='md:mt-6 mt-3'>
          <div className="text-white px-4 md:px-20">
            <div>
              <p className="font-bold text-black md:text-[32px] text-[10px]">Our Culture in 5 Words:</p>
              <p className="text-black font-bold md:mt-5 mt-1 md:text-[32px] text-[10px]">
                <span className="text-black">Empathy.</span>{' '}
                <span className="text-black">Inclusion.</span>{' '}
                <span className="text-black">Trust.</span>{' '}
                <span className="text-black">Innovation.</span>{' '}
                <span className="text-black">Community.</span>
              </p>
              <p className="text-black font-normal md:mt-5 mt-1 md:text-[24px] text-[8px] leading-tight">
                These values guide everything we do—from the code we write to the farmers we serve. They shape how we work, connect, and grow.
              </p>
            </div>
            
            <div className='md:h-5 h-2'></div>
            
            {/* App Download Section */}
            <div className="flex justify-between items-center w-full">
              <a
                href="https://play.google.com/store/apps/details?id=com.farmnet.africa&pcampaignid=web_share"
                className="flex flex-col items-start"
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751889690/google_PLAY-LOGO.WINE_emyxpu.png"
                  className="h-[15px] md:w-[280px] md:h-[180px]"
                  alt="Google Play"
                />
                <p className="md:text-[14px] text-[6px] font-normal md:px-1">
                  Click to download App
                </p>
              </a>

              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
                className="h-[15px] md:h-[76px]"
                alt="Right Logo"
              />
              
              <img
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759750524/Screenshot_2025-10-06_at_4.44.11_PM_akgjiv.png"
                className="h-[15px] md:h-[85px]"
                alt="Right Logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About